import React from 'react';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';

const FooterModern = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column with Logo */}
          <div>
            <div className="mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_grano-v2/artifacts/rir9eg3m_LOGO-FOOTER-e1715783553327-1024x426.png"
                alt="Grano e Sale Logo"
                className="h-24 w-auto mb-4"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Ristorante Pizzeria nel cuore di Narni. Dal 2003 offriamo sapore, tradizione e allegria.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#7f9e60] transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a
                href="#"
                className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#7f9e60] transition-colors"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="text-[#7f9e60] flex-shrink-0 mt-1" size={20} />
                <div>
                  <p className="text-gray-300">Via Flaminia Ternana, 145</p>
                  <p className="text-gray-400 text-sm">05035 Narni (TR)</p>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-[#7f9e60] flex-shrink-0" size={20} />
                <a href="tel:+393471674689" className="text-gray-300 hover:text-[#7f9e60] transition-colors">
                  +39 347 167 4689
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-[#7f9e60] flex-shrink-0" size={20} />
                <a href="mailto:info@granoesale.it" className="text-gray-300 hover:text-[#7f9e60] transition-colors">
                  info@granoesale.it
                </a>
              </li>
            </ul>
          </div>

          {/* Orari */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Orari</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Clock className="text-[#7f9e60] flex-shrink-0 mt-1" size={20} />
                <div>
                  <p className="text-gray-300 font-semibold">Tutti i Giorni</p>
                  <p className="text-gray-400 text-sm">19:30 - 24:00</p>
                </div>
              </div>
            </div>
          </div>

          {/* Link Rapidi */}
          <div>
            <h4 className="text-lg font-bold mb-6 uppercase tracking-wider">Link Rapidi</h4>
            <ul className="space-y-3">
              {[
                { name: 'Chi Siamo', href: '#welcome' },
                { name: 'Prenota', href: '#prenota' },
                { name: 'Gallery', href: '#gallery' },
                { name: 'Menu Completo', href: 'https://pages.pienissimo.com/?hash=f9VvvV5kMOeqsPr7AQGPyOBKUWN6tCL1&id=0VY9ap' },
                { name: 'Menu Senza Glutine', href: 'https://f9vvvv5kmoeqspr7aqgpyobkuwn6tcl1.pages.pienissimo.pro/home?name=%F0%9F%93%9A' },
              ].map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : '_self'}
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-[#7f9e60] transition-colors flex items-center space-x-2 group"
                  >
                    <span className="w-0 h-0.5 bg-[#7f9e60] group-hover:w-4 transition-all duration-300"></span>
                    <span>{link.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-6">
        <div className="container mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm text-gray-400">
            <p>
              © {currentYear} Antares S.r.l. - P.IVA: 01259830550. Tutti i diritti riservati.
            </p>
            <p>
              Made with ❤️ by{' '}
              <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-[#7f9e60] hover:underline">
                Emergent AI
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterModern;
